export const WORKER_JOB_MAP_FEATURE_KEY = 'workforce.job_map'

export const workerMapTiles = {
  url: (import.meta.env.VITE_MAP_TILE_URL as string | undefined) || 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
  attribution: (import.meta.env.VITE_MAP_TILE_ATTRIBUTION as string | undefined) || '&copy; OpenStreetMap contributors',
  maxZoom: Number(import.meta.env.VITE_MAP_MAX_ZOOM || 19),
}

export type EphemeralMapPosition = { latitude: number; longitude: number; accuracyMeters?: number | null }

export function requestEphemeralMapPosition(): Promise<EphemeralMapPosition> {
  return new Promise((resolve, reject) => {
    if (typeof navigator === 'undefined' || !navigator.geolocation) {
      reject(new Error('unavailable'))
      return
    }
    navigator.geolocation.getCurrentPosition(
      (position) => resolve({
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
        accuracyMeters: position.coords.accuracy,
      }),
      (error) => reject(new Error(error.code === error.PERMISSION_DENIED ? 'denied' : 'unavailable')),
      { enableHighAccuracy: false, timeout: 10_000, maximumAge: 60_000 },
    )
  })
}
